/**
 * Convert a base64 image to a file
 *
 * @param {string} url - The base64 image
 * @param {string} fileName - The name of the file
 * @returns {File} The file
 */
export const convertToFile = (url, fileName) => {
    let arr = url.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: mime });
};
